import React from 'react'

import BottomTabs from './BottomTabs'

const Footer: React.FC = () => {
  return <BottomTabs />
}

export default Footer
